module.exports = __webpack_public_path__ + "static/img/services_slide1.2ca8285.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services_slide1.jpg
// module id = 9NYd
// module chunks = 0